import { useCallback } from "react";
import { useSidebar } from "../ui/sidebar";

interface CloseSidebarOnNavigateInput {
  isMobile: boolean;
  setOpenMobile: (open: boolean) => void;
}

export function closeSidebarOnNavigate(input: CloseSidebarOnNavigateInput): void {
  if (!input.isMobile) return;
  input.setOpenMobile(false);
}

export function useCloseSidebarOnNavigate(): () => void {
  const { isMobile, setOpenMobile } = useSidebar();

  return useCallback(() => {
    closeSidebarOnNavigate({ isMobile, setOpenMobile });
  }, [isMobile, setOpenMobile]);
}
